import { createAsyncTypes } from 'utils/ActionCreator'

const BASE_TYPE = 'EmailEncryption/CompanyPolicies'

export const FETCH_POLICIES_SCHEMA_ASYNC = createAsyncTypes('FETCH_POLICIES_SCHEMA', BASE_TYPE)

export const FETCH_POLICIES_CONFIG_ASYNC = createAsyncTypes('FETCH_POLICIES_CONFIG', BASE_TYPE)

export const SAVE_POLICIES_CONFIG_ASYNC = createAsyncTypes('SAVE_POLICIES_CONFIG', BASE_TYPE)
